import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
/**
 * @export
 * A component that displays a skeleton loader for placeholder content during loading.
 *
 * @example
 * ```
 * <SkeletonLoader
 *   width="200px"
 *   height="20px"
 * />
 * ```
 *
 * @example
 * ```
 * <SkeletonLoader
 *   width="100%"
 *   height="2rem"
 *   className="custom-skeleton"
 *   additionalStyle={{ borderRadius: '4px' }}
 * />
 * ```
 */
const SkeletonLoader = ({ width = "100%", height = "1rem", className, additionalStyle }) => {
    return (_jsx("div", { className: classNames('uxpcore_skeleton_loader', className), style: Object.assign(Object.assign({}, additionalStyle), { width, height }) }));
};
export default SkeletonLoader;
